import { IUnitServiceHistoryInputDto, UnitServiceHistoryClient } from 'api/api';
import { AsyncOperationBuilder } from 'utilities/api-helper';
import { toCalendarDay } from 'utilities/date-helpers';
import { unitServiceHistoryClient } from '../api-clients';
import { createUnitServiceHistoryAction, getLatestUnitServiceHistoriesAction, getUnitServiceHistoriesAction } from './actions';

const revokeObjectUrlDelayMs = 40000;

export async function openServiceDocument(unitId: number, id: number) {
	const file = await unitServiceHistoryClient.downloadServiceDocument(unitId, id);
	if (!file?.data) return;

	const fileUrl = URL.createObjectURL(file.data);
	window.open(fileUrl, '_blank');

	// Revoking any sooner leaves the opened tab unable to re-fetch the blob when it reloads or prints.
	setTimeout(() => URL.revokeObjectURL(fileUrl), revokeObjectUrlDelayMs);
}

export function getUnitServiceHistories(unitId: number, startDate?: Date, endDate?: Date) {
	return AsyncOperationBuilder(
		getUnitServiceHistoriesAction,
		apiClient =>
			(apiClient as UnitServiceHistoryClient).getAllUnitServiceHistory(
				unitId,
				startDate && toCalendarDay(startDate),
				endDate && toCalendarDay(endDate)
			),
		undefined,
		unitServiceHistoryClient
	);
}

export function getLatestServiceDocumentTypes(unitId: number) {
	return AsyncOperationBuilder(
		getLatestUnitServiceHistoriesAction,
		apiClient => (apiClient as UnitServiceHistoryClient).getLatestDocumentTypesByUnitId(unitId),
		{ unitId },
		unitServiceHistoryClient
	);
}

export function createUnitServiceHistory(unitServiceHistory: IUnitServiceHistoryInputDto) {
	return AsyncOperationBuilder(
		createUnitServiceHistoryAction,
		apiClient => (apiClient as UnitServiceHistoryClient).uploadServiceDocument(unitServiceHistory.unitId, unitServiceHistory.file, unitServiceHistory.dateOfService, unitServiceHistory.serviceDocumentType, unitServiceHistory.comment),
		unitServiceHistory,
		unitServiceHistoryClient
	);
}
